import clsx from "clsx";
import { NavLink, useLocation } from "react-router-dom";

import { TemplateTypeIcon } from "features/templates/components";
import type { CreatedTemplate } from "features/templates/types";

import { TEMPLATE_METRICS } from "../../constants";

export default function TemplatesListItem({
  template,
}: {
  template: CreatedTemplate;
}) {
  const { search } = useLocation();
  const { id, name, type } = template;

  return (
    <NavLink
      key={id}
      className={({ isActive }) =>
        clsx(
          "group flex items-center gap-x-2 border-t border-t-black-200 p-4 transition-[background,border] lg:border-r-2 lg:hover:bg-purple-50",
          isActive
            ? "lg:border-r-purple-500 lg:bg-purple-50"
            : "border-r-transparent",
        )
      }
      to={{ pathname: id, search }}
    >
      {({ isActive }) => (
        <>
          <TemplateTypeIcon type={type} isSelected={isActive} />
          <div className="flex flex-1 flex-col gap-y-0.5">
            <span className="text-sm-bold">{name}</span>
            <div className="flex gap-x-2.5">
              {TEMPLATE_METRICS.map(({ getLabel, icon: Icon, getValue }) => {
                const label = getLabel(type);
                return (
                  <div key={label} className="flex flex-1 gap-1">
                    <Icon className="size-4 text-black-500" />
                    <span className="text-xs">{getValue(template)}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}
    </NavLink>
  );
}
